import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { GetPunchoutIdentityApiParameter } from "@TKCCP/Services/PunchoutIdentityService";
import PunchoutIdentityPageState from "@TKCCP/Store/Pages/PunchoutIdentity/PunchoutIdentityState";
import { Draft } from "immer";

const initialState: PunchoutIdentityPageState = {
    getPunchoutParameter: { page: 1, pageSize: 8, query: "", expand: ["top3products"], sort: "ModifiedOn DESC" },
};

const reducer = {
    "Pages/PunchoutIdentity/UpdateLoadParameter": (
        draft: Draft<PunchoutIdentityPageState>,
        action: { parameter: PunchoutIdentityPageState },
    ) => {
        draft.getPunchoutParameter = { ...draft.getPunchoutParameter, ...action.parameter };

        for (const key in draft.getPunchoutParameter) {
            const value = (<any>draft.getPunchoutParameter)[key];

            // remove empty parameters
            if (value === "" || value === undefined) {
                delete (<any>draft.getPunchoutParameter)[key];
            }
        }

        for (const key in action.parameter) {
            // go back to page 1 if any other parameters changed
            if (draft.getPunchoutParameter.page && draft.getPunchoutParameter.page > 1 && key !== "page") {
                draft.getPunchoutParameter.page = 1;
            }
        }
    },
    "Pages/PunchoutIdentity/UpdateSearchFields": (
        draft: Draft<PunchoutIdentityPageState>,
        action: { parameter: GetPunchoutIdentityApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getPunchoutParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getPunchoutParameter = { ...initialState.getPunchoutParameter, ...action.parameter };
        } else {
            draft.getPunchoutParameter = { ...draft.getPunchoutParameter, ...action.parameter };

            for (const key in draft.getPunchoutParameter) {
                const value = (<any>draft.getPunchoutParameter)[key];

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getPunchoutParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getPunchoutParameter.page &&
                    draft.getPunchoutParameter.page > 1 &&
                    key !== "page" &&
                    key !== "pageSize"
                ) {
                    draft.getPunchoutParameter.page = 1;
                }
            }
        }
    },

    "Pages/PunchoutIdentity/ClearParameter": (draft: Draft<PunchoutIdentityPageState>) => {
        draft.getPunchoutParameter = {
            ...initialState.getPunchoutParameter,
            pageSize: draft.getPunchoutParameter.pageSize,
        };
    },
};

const punchoutIdentityPageReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).pagePunchoutIdentity = punchoutIdentityPageReducer;
